import Blue from "~/core";

new Blue({
  name: "Form Mutation Observer",
  selector: ".blue-form",
  setup(e) {
    const newDiv = document.createElement("div");
    newDiv.classList.add("forms-hook");
    newDiv.appendChild(e.cloneNode(true));
    e.parentNode.replaceChild(newDiv, e);

    const config = { attributes: true, childList: true, subtree: true };
    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if (
          mutation.type === "childList" &&
          mutation.target.className == "forms-hook"
        ) {
          let validationErrors = [
            ...newDiv.querySelectorAll(".field-validation-error"),
          ];
          validationErrors.forEach((el) => {
            el.role = "alert";
            let value = el.dataset.valmsgFor;
            if(value.includes("Recaptcha")){
              el.innerText="Please complete the reCAPTCHA."
            }
            let spaces = value.split(".").join("_");
            let elem = document.querySelector(`label[for="${spaces}"]`);
            if (elem != null) {
              let text = elem.innerText;
              el.innerText = `${text}: ${el.innerText}`;
            }
          });
        }
      }
    };
    const observer = new MutationObserver(callback);
    observer.observe(newDiv, config);
  },
});

new Blue({
  name: "Form Validate",
  selector: ".form--validate",
  setup(form) {
    this.$validate(form);
  },
});

new Blue({
  name: "Select Text Display",
  selector: "select.form__select",
  setup(select) {
    const inputGroup = select.closest(".form__input-group");
    const textArea = inputGroup.querySelector(".form__optional-text-area");
    const textElement = textArea.querySelector("p.form__optional-text");

    this.$addEvents(select, "change", (e) => {
      if (select.querySelector("option[data-text-display]")) {
        const selectedOption = select.querySelector(
          `option[value="${e.target.value}"]`
        );
        const text = selectedOption.dataset.textDisplay || "";
        const first = textArea.offsetHeight;
        textElement.textContent = text;
        const last = textArea.offsetHeight;
        textArea.animate([{ height: `${first}px` }, { height: `${last}px` }], {
          duration: 250,
          easing: "ease",
        });
      }
    });
  },
});
